import { usePageTitle } from '@/hooks/usePageTitle';
import { createFileRoute } from '@tanstack/react-router'
import { ContinuousPaymentPortoutRequestForm } from '@/features/dashboard/continuous-payment-portout-request/form/ContinuousPaymentPortoutRequestForm';
import { PortoutRequestTypeEnum } from '@/features/dashboard/portout-request/portoutRequestEnum';

export const Route = createFileRoute('/_dashboard/continuous-payment-portout-requests/cancel')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle("継続課金者解約依頼");
  return <ContinuousPaymentPortoutRequestForm requestType={PortoutRequestTypeEnum.Cancel} />
}
